import { ConfirmationDialog } from '@/components/ConfirmationDialog';

interface DeleteApiKeyModalProps {
  open: boolean;
  apiKey: { key: string; name: string } | null;
  onConfirm: () => void;
  onClose: () => void;
  isPending: boolean;
}

/**
 * DeleteApiKeyModal - Confirmation modal for API key deletion
 *
 * Features:
 * - Displays API key name for confirmation
 * - Disabled state during deletion
 * - Automatic close on success/error (handled by parent)
 *
 * Extracted from ApiKeys.tsx (Lines 168-197)
 * Used in: UserSettingsCards
 */
export function DeleteApiKeyModal({
  open,
  apiKey,
  onConfirm,
  onClose,
  isPending,
}: DeleteApiKeyModalProps) {
  return (
    <ConfirmationDialog
      open={open && !!apiKey}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete API Key"
      description={
        apiKey ? `Are you sure you want to delete ${apiKey.name} API key?` : ''
      }
      confirmLabel="Delete"
      loadingLabel="Deleting..."
      isLoading={isPending}
      data-testid="delete-api-key-modal"
    />
  );
}
